import Honeybadger from '@honeybadger-io/js'

import settings from '@/utils/settings'

import {
  DEPLOYED_ENVIRONMENTS,
  ERROR_PROXY_INSTANCE,
  FILTERED_KEYS,
  REDACTED_VALUE
} from './constants'

const RAILS_ENV = process.env.RAILS_ENV

const isDeployedEnvironment = DEPLOYED_ENVIRONMENTS.includes(RAILS_ENV)

const isTestEnvironment = process.env.NODE_ENV === 'test'

const config = {
  apiKey: settings.honeybadger_js_api_key,
  enableUnhandledRejection: true,
  environment: window.environment,
  insightsEnabled: false,
  revision: settings.git_commit_sha
}

const CHUNK_ERROR_PATTERNS = [
  /ChunkLoadError/i,
  /Loading CSS chunk \d+ failed/i
]

export const shouldSuppressNotice = notice => {
  const { name = '', message = '', context = {} } = notice
  const isChunkError = CHUNK_ERROR_PATTERNS.some(
    pattern => pattern.test(name) || pattern.test(message)
  )

  if (!isChunkError) return false

  return context.source !== 'chunk_load_failed'
}

export const isUnhandledRejection = notice => {
  const { name = '', message = '' } = notice

  return name === 'window.onunhandledrejection'
    || message.startsWith('UnhandledPromiseRejectionWarning:')
}

export const shouldSuppressForAnonymousUser = notice =>
  isUnhandledRejection(notice) && window.userLoggedIn === false

export const attachLogRocketSession = notice => {
  const sessionUrl = window?.LogRocket?.sessionURL

  if (!sessionUrl) return

  notice.context = {
    ...(notice.context || {}),
    logrocket_session_url: sessionUrl
  }
}

export const tagBoundaryReports = notice => {
  if (notice.context?.componentStack) {
    notice.context = { ...notice.context, boundary: 'third_party' }
  }
}

const filterValues = object => {
  Object.keys(object || {}).forEach(function(key) {
    if (FILTERED_KEYS.includes(key)) {
      object[key] = REDACTED_VALUE
    }
  })
}

let honeybadger

if(isDeployedEnvironment) {
  honeybadger = Honeybadger.configure(config)

  honeybadger.beforeNotify(notice => {
    if (shouldSuppressForAnonymousUser(notice)) return false
    if (shouldSuppressNotice(notice)) return false

    filterValues(notice.params)
    filterValues(notice.params?.user_form)

    tagBoundaryReports(notice)
    attachLogRocketSession(notice)
  })

  honeybadger.setContext({ user_id: window.userId })
}

window.addEventListener('load', () => {
  const host = window.location.host

  if (settings.allowed_hosts && !settings.allowed_hosts.some(
    allowedHost => host.indexOf(allowedHost) !== -1
  )) {
    logError(ERROR_PROXY_INSTANCE, {
      name: ERROR_PROXY_INSTANCE,
      params: { host }
    })
  }
})

export function logError(error, options) {
  if(isDeployedEnvironment) {
    honeybadger.notify(error, options)
  } else if(!isTestEnvironment) {
    console.error(error)
  }
}

export default honeybadger
